import React from 'react';
import type { IProps as IScriptBlockProps } from './ScriptBlock.interface';
import { ScriptBlock } from './ScriptBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IScriptBlockInputProps {
    content: string;
    base64EncodedText?: boolean;
    className?: string;
}

const mapInputToProps = (input: IScriptBlockInputProps): IScriptBlockProps => {
    return {
        content: input.content,
        base64EncodedText: input.base64EncodedText,
        className: input.className
    };
};

const ScriptBlockTranslation: React.FC<IScriptBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={ScriptBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default ScriptBlockTranslation;